module.exports = __webpack_public_path__ + "static/media/img-reason-card-bg.26f95a0d.png";